import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { Observable, of } from 'rxjs';
import { delay, map, startWith } from 'rxjs/operators';
import { stringify } from 'querystring';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import { AppComponent } from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';

declare var $: any;
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
export interface fillingOppositeParty {
  ID: string;
  Name: string;
  Mobile: string;
  State: string;
  City: string;
  typ: string;
}
export interface Insertdecision {
  id: Int16Array;
  Description: string;
  TargetDt: string;
  DueDt: string;
  DateofDecision: string;
  facts: string;
  ActionType: string;
  ActionTakenBy: string;
  recEnable: Int16Array;
  recUser: Int16Array;
  recAddUser: Int16Array;
  fileSize: string;
  fileName: string;
  fileBase: any;
  FillingParty: string;
  OppositeParty: string;
}

@Injectable({ providedIn: 'root' })
@Component({
  selector: 'app-create-decision',
  templateUrl: './create-decision.component.html',
  styleUrls: ['./create-decision.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  standalone: false
})
export class CreateDecisionComponent implements OnInit {
  TypeHeader: string;
  Type: string;
  id: any;
  Manager: any;
  Leader: any;
  User: any;
  url: string;
  pageurl: string;
  addFormDecision: FormGroup;
  getdata: string;
  numb: any;
  DueDate: string;
  DateofDecision: string;
  TargetDate: string;
  str: string;
  FillingOppoParty: fillingOppositeParty[] = [];
  filteredFillingParty: fillingOppositeParty[] = [];
  filteredOppositeParty: fillingOppositeParty[] = [];
  selectedFillingParty = [];
  selectedOppositeParty = [];
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2090, 0, 1);
  DisplaySaveNoticeButton: string;
  HeaderButtonCaption: string;
  editable: boolean;
  DownloadURL: string;
  statusNo: any;
  HideCaseNotice: string;
  HideClosed: string;
  HideStatus: string;
  CaptionLabel: string;
  OutputValue: any;
  HideButtonSubmit: string;
  HeaderButtonCaptionValue: number;
  NoticeCaseData: any;
  fileurls = [];
  dtColumns = [];
  fileSize: string;
  fileName: string;
  clicked: boolean;
  RightsID: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  Captions: any = {};
  typeOfAction: any;
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, public datepipe: DatePipe, protected alertService: AlertService) {
    this.url = AppComponent.baseURL;
    this.DownloadURL = AppComponent.DownloadURL;
  }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202038001') || this.RightsID.includes('202038021') || this.RightsID.includes('202038000')) {
    } else {
      window.location.href = "module/0";
    }
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = 0;
    this.DisplaySaveNoticeButton = "submit";
    this.HeaderButtonCaption = "Create";
    this.HideStatus = "!isHidden";
    this.CaptionLabel = "";
    this.OutputValue = "";
    this.HideButtonSubmit = "";
    this.HideClosed = "!isHidden";
    this.HeaderButtonCaptionValue = 0;
    this.getCaptionData();
    this.http.get(this.url + 'Help/FetchHelpFillingOpposite')
      .subscribe((data) => {
        if (data == null) {
          this.FillingOppoParty = null;
        } else {
          this.FillingOppoParty = JSON.parse(data.toString());
          this.filteredFillingParty = [...this.FillingOppoParty];
          this.filteredOppositeParty = [...this.FillingOppoParty];
        }
      }
      );
    // Set Validation of Add Notice / Case Form on Header Part
    this.addFormDecision = this.formBuilder.group({
      Description: ['', Validators.required], TargetDate: ['', Validators.required], BriefFacts: ['', Validators.required],
      ActionType: [null, Validators.required], ActionTakenBy: ['', Validators.required], DueDate: [''], DateofDecision: ['', Validators.required], browseFiles: [''],
      fillingPartyName: [null, Validators.required], oppositePartyName: [null, Validators.required],
    });
    // React to changes
    this.addFormDecision.get('fillingPartyName')?.valueChanges.subscribe(val => {
      this.selectedFillingParty = val || [];
      this.updateFilters();
    });

    this.addFormDecision.get('oppositePartyName')?.valueChanges.subscribe(val => {
      this.selectedOppositeParty = val || [];
      this.updateFilters();
    });

        // 140= Designation
    this.getMaster('140', '').subscribe((data: any) => {
      this.typeOfAction = data;
    }); 
  }
  getCaptionData(): void {
    this.http.get<any>(`${this.url}Dashboard/CaptionData?id=`).subscribe({
      next: (res) => {
        const data = typeof res === 'string' ? JSON.parse(res) : res;

        const filtered = data.filter((x: any) => x.MainId === "5");

        filtered.forEach((element: any) => {
          const key = element?.SubDescr
          ?.replace(/\s+/g, '_')
          ?.replace(/[\/()]/g, '')
          ?.replace(/_+/g, '_')
          ?.trim().toLowerCase();
          if (key) {
            this.Captions[key] = element.SelectedValue;
          }
        });

        console.log(this.Captions, "Caption Data Map");
      },
      error: (err) => {
        console.error('Error fetching caption data', err);
      }
    });
  }

  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }
  
  // function f() for display validation on header part
  get f() { return this.addFormDecision.controls; }
  onSelectFile(event) {
    this.fileurls = [];
    this.fileName = '';
    this.fileSize = '';
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        this.fileName += event.target.files[i].name + ',';
        this.fileSize += event.target.files[i].size + ',';
        let reader = new FileReader();
        reader.onload = (event: any) => { this.fileurls.push(event.target.result); };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  updateFilters() {
    // Remove opposite party selections from filling party list
    this.filteredFillingParty = this.FillingOppoParty.filter(
      item => !this.selectedOppositeParty?.includes(item.ID)
    );

    // Remove filling party selections from opposite party list
    this.filteredOppositeParty = this.FillingOppoParty.filter(
      item => !this.selectedFillingParty?.includes(item.ID)
    );
  }
  onSubmit(HeaderFormData) {
    if (this.addFormDecision.invalid) {
      this.addFormDecision.markAllAsTouched();
      return;
    }
    // ---------- VALIDATION ----------
    // if (!HeaderFormData.Description) {
    //   this.alertService.showError('Please Enter Decision Point');
    //   return;
    // } else if (!HeaderFormData.DateofDecision) {
    //   this.alertService.showError('Please Enter Date of Decision');
    //   return;
    // } else if (!HeaderFormData.TargetDate) {
    //   this.alertService.showError('Please Enter Target Date');
    //   return;
    // } else if (!HeaderFormData.BriefFacts) {
    //   this.alertService.showError('Please Enter Brief Facts');
    //   return;
    // } else if (!HeaderFormData.ActionType) {
    //   this.alertService.showError('Please Enter Action Type');
    //   return;
    // } else if (!HeaderFormData.ActionTakenBy) {
    //   this.alertService.showError('Please Enter Action Taken By');
    //   return;
    // }

    const targetDate = this.datepipe.transform(HeaderFormData.TargetDate, 'yyyy-MM-dd');
    const decisionDate = this.datepipe.transform(HeaderFormData.DateofDecision, 'yyyy-MM-dd');
    const dueDate = this.datepipe.transform(HeaderFormData.DueDate, 'yyyy-MM-dd');

    if (targetDate < decisionDate) {
      this.alertService.showError('Target Date must be greater or equal to Date Of Decision');
      return;
    } else if (dueDate < decisionDate) {
      this.alertService.showError('Due Date must be greater or equal to Date Of Decision');
      return;
    } else if (dueDate < targetDate) {
      this.alertService.showError('Due Date must be greater or equal to Target Date');
      return;
    } else if (!HeaderFormData.ActionTakenBy) {
      this.alertService.showError('Please Enter Action Taken By');
      return;
    } else if (this.addFormDecision && this.addFormDecision.invalid) {
      return;
    }

    // ---------- CREATE OBJECT ----------
    this.numb = 1;
    const decisionobj = {
      id: this.id,
      fileSize: this.fileSize,
      fileBase: this.fileurls,
      fileName: this.fileName,
      Description: HeaderFormData.Description,
      TargetDt: HeaderFormData.TargetDate,
      DueDt: HeaderFormData.DueDate,
      DateofDecision: HeaderFormData.DateofDecision,
      facts: HeaderFormData.BriefFacts,
      ActionType: HeaderFormData.ActionType,
      ActionTakenBy: HeaderFormData.ActionTakenBy,
      FillingParty: HeaderFormData.fillingPartyName ? HeaderFormData.fillingPartyName.toString() : '',
      OppositeParty: HeaderFormData.oppositePartyName ? HeaderFormData.oppositePartyName.toString() : '',
      recEnable: this.numb,
      recUser: this.numb,
      recAddUser: this.numb
    };

    // ---------- API CALL ----------
    this.http.post(this.url + 'CorporateDecision/InsertUpdateNoticePlanning', decisionobj)
      .subscribe(
        (data: any) => {
          if (!data) {
            this.alertService.showError('Some Error In Entered Record');
          } else {
            if (this.id === 0) {
              // this.alertService.showSuccess('Decision Added Successfully');
              const parts = data.toString().split(':');
              const recordId = parts[1] ? parts[1].split('}')[0] : '';
              this.alertService.showConfirm('Do you want to fill further details?').then((result) => {
                if (result) {
                  window.location.href = 'corporate-decision/' + recordId;
                }
              });
            }
          }
          this.addFormDecision.reset();
        },
        (error) => {
          this.alertService.showError('Server Error: Unable to save data.');
        }
      );
  }

  goBack() {
    window.history.back();
  }
}
